import ComponentLayout from 'common/ComponentLayout/Component';
import SalaryForm from './SalaryForm.js/SalaryForm';

const Salary = () => <ComponentLayout title="Salary" component={SalaryForm} />;
export default Salary;
